import React from 'react'
import { Box, Theme, Typography, useMediaQuery } from '@mui/material'

interface Props {
  title?: string
  children?: React.ReactNode
}

/**
 * The header of a chart displaying a title
 */
const ChartHeader: React.FC<Props> = ({ title, children }) => {
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box sx={{ flex: 1 }} />
      {title && (
        <Box sx={{ display: 'flex', justifyContent: 'center', flex: 'none' }}>
          <Typography variant="h3" style={{ maxWidth: downSm ? 240 : 'none', textAlign: 'center', whiteSpace: 'normal', wordBreak: 'break-word' }}>
            {title}
          </Typography>
        </Box>
      )}
      <Box sx={{ flex: 1 }}>{children}</Box>
    </Box>
  )
}

export default ChartHeader
